/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  Grid,
  Button,
  Slider,
  IconButton,
  Tooltip,
  Dialog,
  CircularProgress,
} from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { v4 as uuidv4 } from 'uuid';

import Actions from "../../fluid/Actions/ActionFactory";

import FDropDown from "../../fluid/Elements/Inputs/FDropDown";
import config_wv from "../../configs/composites/ConfigureWorldView";
import { Clear, Add, CheckCircleOutlined } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Zoom from "@material-ui/core/Zoom";
import Grow from "@material-ui/core/Grow";

import OpsConfig from "./OpsConfig/OpsConfig";

const clone = require("rfdc")();

const styles = (theme) => ({});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#f50157",
    },
  },
});

const temp_field = {
  name: "",
  role: "",
  weight: 0,
};

const ops = {
  Recommend: {
    name: "Recommendation",
    config: true,
    ops : [
      {
        name : "Top K",
        type : "number",
        field : "top_k",
        adornment : null,
        default : 10
      },
      {
        name : "Enable Reranker",
        type : "boolean",
        field : "enable_reranker",
        adornment : null,
        default : false
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: ["Predictor"],
      weight_validation: true,
    }
  },
  Classify: {
    name: "Classification",
    config: true,
    ops: [
      {
        name : "Classification Top K",
        type : "number",
        field : "trng_classify_top_k",
        adornment : null,
        default : 100
      },
      {
        name : "Enable Reranker",
        type : "boolean",
        field : "enable_reranker",
        adornment : null,
        default : false
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: ["Label", "Predictor"],
      weight_validation: true,
    },
  },
  TopicModel: {
    name: "Thematic Distribution",
    config: true,
    ops : [
      {
        name : "Total number of themes",
        type : "number",
        default : 10,
        adornment : null,
        field : "number_of_clusters"
      },
      {
        name : "Max Threshold to group themes",
        type : "number",
        default : 2,
        adornment : {
          start : null,
          end : "%"
        },
        field : "match_threshold"
      },
      {
        name : "Number of Representative Cases",
        type : "number",
        default : 10,
        adornment : null,
        field : "number_of_representative_tickets"
      },
      {
        name : "Descriptors per theme",
        type : "number",
        default : 25,
        adornment : null,
        field : "terms_per_cluster"
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: ["Predictor"],
      weight_validation: false,
    },
  },
  ImageToText: {
    name: "Summarizer",
    config: false,
    ops: [],
    validation: {
      field_config_required: false,
      ops_config_required: false,
      validation_required: false,
      empty_fields_allowed: false,
      zero_fields_allowed: true,
      should_contain_type: [],
      weight_validation: false,
    },
  },
  LangDetect: {
    name: "Language Detector",
    config: false,
    ops: [],
    validation: {
      field_config_required: false,
      ops_config_required: false,
      validation_required: false,
      empty_fields_allowed: false,
      zero_fields_allowed: true,
      should_contain_type: [],
      weight_validation: false,
    },
  },
  NER: {
    name: "Contextual Identity Extractor",
    config: false,
    ops: [],
    validation: {
      field_config_required: false,
      ops_config_required: false,
      validation_required: false,
      empty_fields_allowed: false,
      zero_fields_allowed: true,
      should_contain_type: [],
      weight_validation: false,
    },
  },
  IRC : {
    name : "Intelligent Row Consolidation",
    config : true,
    ops : [
      {
        name: "Global Record Identifier",
        type : "text",
        default : "",
        adornment : null,
        field : "global_record_identifier"
      },
      {
        name : "Drop Exact Duplicates",
        type : "boolean",
        field : "drop_exact_duplicates",
        adornment : null,
        default : false
      },
      {
        name : "Two Tables",
        type : "boolean",
        default : false,
        adornment : null,
        field : "two_tables"
      },
      {
        name : "Table A Identifiers",
        type : "text_list",
        default : [],
        adornment : null,
        field : "table_A_identifiers"
      },
      {
        name : "Table B Identifiers",
        type : "text_list",
        default : [],
        adornment : null,
        field : "table_B_identifiers"
      },
      {
        name : "Mapping Type",
        type : "select",
        default : null,
        adornment : null,
        field : "mapping_type",
        options : ["one-to-one", "many-to-one", "many-to-many"]
      },
      {
        name: "Export Workflow",
        type : "text",
        default : "",
        adornment : null,
        field : "export_workflow"
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: [],
      weight_validation: false,
    }
  },
  IFC : {
    name : "Intelligent Field Consolidation",
    config : true,
    ops : [
      {
        name : "Global Information Unit",
        type : "text",
        default : "",
        adornment : null,
        field : "global_schema_IU"
      },
      {
        name : "Case Sensitive",
        type : "boolean",
        default : false,
        adornment : null,
        field : "case_sensitive"
      },
      {
        name : "Max Empty Threshold",
        type : "slider",
        default : 0.9,
        adornment : null,
        step_size : 0.001,
        field : "max_empty_threshold"
      },
      {
        name : "Use Distance Metric",
        type : "boolean",
        default : false,
        adornment : null,
        field : "use_distance_metric"
      },
      {
        name : "Display name for global field",
        type : "text",
        default : "Global",
        adornment : {
          end : 'field'
        },
        field : "global_field_display_name"
      },
      {
        name : "Display name for Groups",
        type : "text",
        default : "Group",
        adornment : null,
        field : "group_display_name"
      },
      {
        name : "Display name for Field",
        type : "text",
        default : "Field",
        adornment : null,
        field : "field_display_name"
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: ["StandardColumn", "ValueColumn", "NameColumn"],
      weight_validation: false,
    }
  },
  PII : {
    name : "PII Detection",
    config : true,
    ops : [
      {
        name : "Redaction Type",
        type : "select",
        default : "Redact",
        adornment : null,
        field : "redaction_type",
        options : ["Redact", "Highlight"],
        field_required : true
      },
      {
        name : "Redaction Path",
        type : "text",
        default : "",
        adornment : null,
        field : "redaction_path"
      }
    ],
    validation: {
      field_config_required: true,
      ops_config_required: true,
      validation_required: true,
      empty_fields_allowed: false,
      zero_fields_allowed: false,
      should_contain_type: [],
      weight_validation: false
    }
  }
};

let validation = {
  zero_fields_allowed: false,
  must_contain_field_type: ["Label"],
};

class ConfigureOps extends Component {
  state = {
    ic_name: "",
    ic_ops: [],
    tabValue: 0,
    insetTabValue: 0,
    configs: [],
    submitted_ops: [],
    reset_dialog: false,
    cur_ops_name: "",
    wv_fields: [],
    field_roles: [],
    content_height: null,
    content_ready: false,
    weight_restriction: 1.0,
  };

  tabPanel = React.createRef();
  headingPanel = React.createRef();

  componentWillMount() {
    console.log("IC_Name: ", this.props.ic_name);
    console.log("Submitted Ops: ", this.state.submitted_ops);

    this.setState({ loading: true });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/world_view_fields",
      method: "get",
      data: {},
    })
      .then((res) => {
        let fields = res.data.result.map((field) => {
          return {
            value: field.name,
            label: field.name,
          };
        });

        Actions("http_request", {
          url:
            "/sainapse/information_channel/" +
            this.props.ic_name +
            "/operations",
          method: "get",
          data: {},
        })
          .then((res) => {
            let submitted_ops = [];
            res.data.result.map((op) => {
              if (ops[op.type].config === false) {
                submitted_ops.push(op.type);
              }
            });

            this.setState(
              {
                ...this.state,
                ic_ops: res.data.result,
                ic_name: this.props.ic_name,
                submitted_ops: submitted_ops,
                tabValue: 0,
                configs: this.generateEmptyConfigs(fields, res.data.result),
                wv_fields: fields,
                loading: false,
              },
              () => {
                console.log("Config Ops State: ", this.state);
              }
            );
          })
          .catch((err) => {
            this.setState({ loading: false });
            console.log(err);
          });
      })
      .catch((err) => console.log(err));

    Actions("http_request", {
      url: "/sainapse/field_roles",
      method: "get",
      data: {},
    })
      .then((res) => {
        let roles = res.data.result.map((role) => {
          return {
            value: role.type,
            label: role.annotation,
          };
        });
        this.setState({ field_roles: roles });
      })
      .catch((err) => console.log(err));
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevState.configs.length === 0 && this.state.configs.length !== 0) {
      let content_height =
        this.props.maxHeight -
        this.tabPanel.current.clientHeight -
        this.headingPanel.current.clientHeight;
      this.setState({ ...this.state, content_height: content_height });
    }

    if (
      prevState.content_ready === false &&
      this.state.content_ready === true
    ) {
      let inset_content_height =
        this.state.content_height - this.insetHeading.current.clientHeight;
      this.setState({
        ...this.state,
        inset_content_height: inset_content_height,
      });
    }
  }

  generateEmptyConfigs = (fields, operations) => {
    let configs = operations.map((operation) => {
      let rules = ops[operation.type]
      let additional_params = {}
      rules.ops.map(op_param => {
        additional_params[op_param.field] = op_param.default
      })
      let config = {
        operation: operation.type,
        op_annot: operation.annotation,
        submit_time: "",
        submit_error: false,
        error_message: "",
        edit: true,
        fields: fields.map((field) => {
          let new_id = uuidv4()
          return {
            id: new_id,
            name: field.value,
            roles: [],
            weight: -1,
            error: false,
            error_message: "",
          };
        }),
        ops_params : {...additional_params}
      };
      return config;
    });

    return configs;
  };

  updateConfig = (ops_name, config) => {
    console.log("Updating Ops Name :", ops_name);
    console.log("Update Config :", config);
    let new_state = clone(this.state);
    let ops_index = new_state.configs.findIndex(
      (config) => config.operation === ops_name
    );
    new_state.configs[ops_index] = { ...config };
    console.log("Config to update :", new_state);
    this.setState({ ...new_state }, () =>
      console.log("Updated Config State :", this.state)
    );
  };

  renderTabs = () => {
    let tabs = this.state.ic_ops.map((operation) => {
      return (
        <Tab
          key={operation}
          label={
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography variant="button">{operation.annotation}</Typography>
            </div>
          }
        />
      );
    });
    return tabs;
  };

  handleFinish = () => {
    this.props.nextStep();
  };

  handleTabNav = (direction) => {
    if (direction === "next") {
      this.setState({ ...this.state, tabValue: this.state.tabValue + 1 });
    } else if (direction === "previous") {
      this.setState({ ...this.state, tabValue: this.state.tabValue - 1 });
    }
  };

  renderNavButtons = (tabValue) => {
    console.log("nav", this.state);
    if (this.state.configs.length === 1) {
      return (
        <Button
          style={{ marginLeft: "10px" }}
          color="secondary"
          size="small"
          disableTouchRipple
          disabled={
            this.state.ic_ops.length !== this.state.submitted_ops.length
              ? true
              : false
          }
          endIcon={<ArrowForwardIosIcon />}
          onClick={() => this.handleFinish()}
        >
          Finish
        </Button>
      );
    } else {
      if (tabValue === 0) {
        return (
          <Button
            style={{ marginLeft: "10px" }}
            color="primary"
            size="small"
            disableTouchRipple
            endIcon={<ArrowForwardIosIcon fontSize="small" />}
            onClick={() => this.handleTabNav("next")}
          >
            {this.state.configs[tabValue + 1].op_annot}
          </Button>
        );
      } else if (tabValue > 0 && tabValue < this.state.configs.length - 1) {
        return (
          <Fragment>
            <Button
              style={{ marginLeft: "10px" }}
              color="primary"
              size="small"
              disableTouchRipple
              startIcon={<ArrowBackIosIcon />}
              onClick={() => this.handleTabNav("previous")}
            >
              {this.state.configs[tabValue - 1].op_annot}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              color="primary"
              size="small"
              disableTouchRipple
              endIcon={<ArrowForwardIosIcon />}
              onClick={() => this.handleTabNav("next")}
            >
              {this.state.configs[tabValue + 1].op_annot}
            </Button>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <Button
              style={{ marginLeft: "10px" }}
              color="primary"
              size="small"
              disableTouchRipple
              startIcon={<ArrowBackIosIcon />}
              onClick={() => this.handleTabNav("previous")}
            >
              {this.state.configs[tabValue - 1].op_annot}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              color="secondary"
              size="small"
              disabled={
                this.state.ic_ops.length !== this.state.submitted_ops.length
                  ? true
                  : false
              }
              disableTouchRipple
              endIcon={<ArrowForwardIosIcon />}
              onClick={() => this.handleFinish()}
            >
              Finish
            </Button>
          </Fragment>
        );
      }
    }
  };

  // finishReady = () => {
  //     console.log('IC Ops: ',this.state.ic_ops.length)
  //     console.log('Submit Ops: ', this.state.submitted_ops.length)
  //     if (this.state.ic_ops.length === this.state.submitted_ops.length) {
  //         return false
  //     } else {
  //         return true
  //     }
  // }

  renderTabPanels = (tabValue) => {
    if (this.state.configs.length !== 0) {
      let config = this.state.configs[tabValue];

      const { classes } = this.props;
      return (
        <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
          <div
            ref={this.headingPanel}
            style={{
              backgroundColor: "#F0F0F0",
              display: "flex",
              flexDirection: "row",
              padding: "5px",
            }}
          >
            <Typography style={{ flexGrow: 1 }} variant="h6">
              {config.op_annot} Configuration
            </Typography>
            <ThemeProvider theme={blue_theme}>
              {this.renderNavButtons(tabValue)}
            </ThemeProvider>
          </div>
          {this.renderTabContent(tabValue)}
        </div>
      );
    }
  };

  renderTabContent = (tabValue) => {
    console.log("Setting For : ", ops[this.state.configs[tabValue].operation])
    if (this.state.content_height !== null) {
      return (
        <OpsConfig
          key={this.state.configs[tabValue].operation}
          content_height={this.state.content_height}
          config={this.state.configs[tabValue]}
          validation_config={
            ops[this.state.configs[tabValue].operation].validation
          }
          ops = {
            ops[this.state.configs[tabValue].operation].ops
          }
          wv_fields={this.state.wv_fields}
          field_roles={this.state.field_roles}
          update_config={(ops_name, config) =>
            this.updateConfig(ops_name, config)
          }
          submit_config={(ops_name) => this.submitConfig(ops_name)}
          edit_ops={(ops_name) => this.editOps(ops_name)}
        />
      );
    }
  };

  // renderTabContent = () => {
  //     const { classes } = this.props
  //     if (this.state.content_height !== null) {
  //         return (
  //             <div style = {{width : '100%', height: this.state.content_height, display: 'flex', flexDirection : 'row'}}>
  //                 <ThemeProvider theme = {blue_theme}>
  //                     <div className = {classes.insetTab}>
  //                         <Tabs
  //                             orientation = 'vertical'
  //                             value={this.state.insetTabValue}
  //                             onChange={this.handleInsetTabChange}
  //                             indicatorColor="primary"
  //                             textColor="primary"
  //                             centered
  //                         >
  //                             <Tab label = "Fields"/>
  //                             <Tab label = "Operation"/>
  //                         </Tabs>
  //                     </div>
  //                     <div style = {{padding: '5px',flexGrow : 1}}>
  //                         {this.renderInsetTabs(this.state.tabValue, this.state.insetTabValue)}
  //                     </div>
  //                 </ThemeProvider>
  //             </div>
  //         )
  //     }
  // }

  // renderInsetTabs = (tabValue, insetTabValue) => {
  //     if (this.state.configs.length !== 0) {
  //         if (this.state.content_ready === false) {
  //             this.setState({...this.state, content_ready : true})
  //         }
  //         let config = this.state.configs[tabValue]

  //         const { classes } = this.props

  //         if (this.state.insetTabValue === 1) {
  //             return this.renderOpsTab(config)
  //         } else if (this.state.insetTabValue === 0) {
  //             return this.renderFieldsTab(config)
  //         }
  //     }
  // }

  // renderFieldsTab = (config) => {
  //     return (
  //         <div style = {{maxHeight : '100%', display : 'flex', flexDirection : 'column'}}>
  //             <div ref = {this.insetHeading} style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', marginBottom : '5px'}}>
  //                 <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row'}}>
  //                     <Typography  variant = 'button'>Field Level Configuration</Typography>
  //                     {this.state.submitted_ops.includes(config.operation) ? <CheckCircleOutlined fontSize = 'small' style = {{color : '#4caf50', marginLeft: '10px'}}/> : null}
  //                 </div>
  //                 {/* <Tooltip title = 'Add Field'>
  //                     <Button style = {{marginRight : '10px'}} size = 'small' variant = 'contained' color = 'primary' onClick = {() => this.addField(config.operation)}>
  //                         Add Field
  //                     </Button>
  //                 </Tooltip> */}
  //                 <Tooltip title = 'Reset Configuration'>
  //                     <Button
  //                         style = {{marginRight : '10px'}}
  //                         size = 'small' variant = 'contained'
  //                         color = 'secondary'
  //                         disabled = {config.fields.length > 0 ? false : true}
  //                         onClick = {() => this.setState({...this.state, reset_dialog : true, cur_ops_name : config.operation})}
  //                     >
  //                         Reset
  //                     </Button>
  //                 </Tooltip>
  //                 <Tooltip title = 'Submit Configuration'>
  //                     <Button
  //                         color = 'primary'
  //                         variant = 'contained'
  //                         size = 'small'
  //                         onClick = {() => this.submitConfig (config.operation)}
  //                     >Submit</Button>
  //                 </Tooltip>
  //             </div>
  //             <Divider style ={{marginBottom : '5px'}} />
  //             <div style = {{height : this.state.inset_content_height, maxHeight : this.state.inset_content_height, flexGrow : 1, overflow : 'scroll'}}>
  //                 <Grid container xs = {12} spacing = {0} direction = 'row' wrap = 'wrap' alignItems = 'center'>
  //                     {this.generateFields(config.fields, config.operation)}
  //                     <Grid item xs = {4}>
  //                         <IconButton
  //                             style = {{display : 'block'}}
  //                             color = 'primary'
  //                             size = 'small'
  //                             onClick = {() => this.addField(config.operation)}
  //                         >
  //                             <Add/>
  //                         </IconButton>
  //                     </Grid>
  //                 </Grid>
  //             </div>
  //         </div>
  //     )
  // }

  // handleConfigFieldChange = (key, value, index, ops_name) => {
  //     let new_state = clone(this.state)
  //     new_state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             if (key[0] === 'role') {
  //                 let similar_field_index = config.fields.findIndex(
  //                     field => field.name === config.fields[index].name && field.role === value
  //                 )

  //                 if (similar_field_index === -1) {
  //                     config.fields[index][key[0]] = value
  //                     config.fields[index].weight = value !== 'Predictor' ? -1 : 0
  //                     config.fields[index].error = false
  //                 } else {
  //                     config.fields[index].error = true
  //                     config.fields[index].error_message = 'The same field with this role exists.'
  //                     config.fields[index][key[0]] = value
  //                     config.fields[index].weight = value !== 'Predictor' ? -1 : 0
  //                 }
  //             } else {
  //                 config.fields[index][key[0]] = value
  //             }
  //         }
  //     })

  //     this.setState({...new_state}, () => console.log('Config Ops Field State: ', this.state))
  // }

  // handleWeightConfigFieldChange = (key, value, index, ops_name) => {
  //     let new_state = clone(this.state)
  //     new_state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             console.log('Restriction For: ', index)
  //             console.log('Restriction at :', this.findSliderValueRestriction(index, ops_name))
  //             if (value <= this.findSliderValueRestriction(index, ops_name)) {
  //                 config.fields[index][key] = value
  //             }
  //         }
  //     })

  //     this.setState({...new_state})
  // }

  // findSliderValueRestriction = (index, ops_name) => {
  //     let restricted_value  = 1.0
  //     let current_total = 0.0

  //     this.state.configs.map((config)=> {
  //         if (config.operation === ops_name) {
  //             let fields = config.fields
  //             fields.map((field, i) => {
  //                 if (index !== i) {
  //                     if (field.weight !== -1) {
  //                         current_total = current_total + field.weight
  //                     }
  //                 }
  //             })
  //         }
  //     })

  //     restricted_value = restricted_value - current_total
  //     return Math.round((restricted_value + Number.EPSILON) * 100) / 100
  // }

  // addField = (ops_name) => {
  //     let new_state = clone(this.state)
  //     new_state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             config.fields.push({
  //                 name: "",
  //                 role: "",
  //                 weight : -1,
  //                 error : false,
  //                 error_message : ""
  //             })

  //         }
  //     })

  //     this.setState({...new_state})
  // }

  // removeField = (ops_name, index) => {
  //     let new_state = clone(this.state)
  //     new_state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             console.log('Fields Before Removing : ', config.fields)
  //             config.fields.splice(index, 1)
  //             console.log('Fields After Removing ' + index + ': ' + config.fields)
  //         }
  //     })

  //     this.setState({...new_state, removing_index : null})
  // }

  // removeCurField = (ops_name, index) => {
  //     this.setState({...this.state, removing_index : index})
  // }

  // resetConfig = (ops_name) => {
  //     let new_state = clone(this.state)
  //     new_state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             config.fields = []
  //         }
  //     })
  //     this.setState({...new_state, reset_dialog : false})
  // }

  editOps = (ops_name) => {
    let new_state = clone(this.state);

    new_state.configs.forEach((config) => {
      if (config.operation === ops_name) {
        config.edit = true;
      }
    });

    this.setState({ ...new_state });
  };

  submitConfig = (ops_name) => {
    console.log("Submitting Config For Op: ", ops_name);
    let fields = [];
    let ops_params = {}

    //generate fields in api payload accepting structure
    this.state.configs.forEach((config) => {
      if (config.operation === ops_name) {
        console.log("Config :", config.fields);
        console.log("Config Fields :", config.fields);
        config.fields.forEach((field) => {
          //each field will have one or more roles
          //for each role create new object

          field.roles.forEach((role) => {
            let clean_field = {
              name: field.name,
              role: role,
            };
            if (role === "Predictor") {
              clean_field.weight = field.weight;
            }
            fields.push(clean_field);
          });
        });
        ops_params = {...config.ops_params}
      }
    });

    console.log("Submitting Fields: ", fields);
    let config_data = {
      fields : fields,
      operation : ops_name,
      config_params : {...ops_params}
    }

    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.state.ic_name +
        "/world_view/config/",
      method: "post",
      data: config_data,
    })
      .then((res) => {
        let new_state = clone(this.state);
        if (!new_state.submitted_ops.includes(ops_name)) {
          new_state.submitted_ops.push(ops_name);
        }
        new_state.configs.forEach((config) => {
          if (config.operation === ops_name) {
            config.edit = false;
            config.submit_time = res.data.timestamp;
            config.submit_error = false;
            config.error_message = "";
          }
        });

        this.setState({ ...new_state }, () =>
          console.log("Submit Ops State: ", this.state)
        );
      })
      .catch((err) => {
        console.log("Error :", err.response);
        let new_state = clone(this.state);
        let error_messages = err.response.data.errors.map((error) => {
          return error.message;
        });
        new_state.configs.forEach((config) => {
          if (config.operation === ops_name) {
            config.edit = true;
            config.submit_error = true;
            config.error_message = "[ " + error_messages.join(", ") + " ]";
          }
        });

        this.setState({ ...new_state });
      });
  };

  validateAndSubmit = (ops_name) => {
    let validation = this.validate(ops_name);
  };

  validate = (ops_name) => {
    let validation_status = [];

    let validation_params = ops[ops_name];
  };

  // generateFields = (ops_fields, ops_name) => {
  //     let fields = ops_fields.map((field, index) => {
  //         return (
  //             <Zoom in={this.state.removing_index === index ? false : true} onExited = {() => this.removeField(ops_name, index)}>
  //                 <Grid xs = {4} item spacing = {0}>
  //                     <Paper elevation = {3} style = {{margin : '5px', padding : '5px'}}>
  //                         <div style = {{width : '100%', display : 'flex', flexDirection: 'row'}}>
  //                             <Typography style = {{flexGrow : 1, margin : 0, padding : 0}} variant = 'caption'>World View Field</Typography>
  //                             <Tooltip title = 'Remove Field'>
  //                                 <IconButton color = 'secondary' size = 'small' onClick = {() => this.removeCurField(ops_name, index)}>
  //                                     <Clear fontSize = 'small'/>
  //                                 </IconButton>
  //                             </Tooltip>
  //                         </div>
  //                         <div style = {{width : '100%'}}>
  //                             <FDropDown
  //                                 key = {ops_name + index + 'name' + field.name}
  //                                 instance = {{
  //                                     label : 'Field Name',
  //                                     helper_text : field.error === true ? field.error_message : 'Choose the World View Field',
  //                                     props : {
  //                                         width : '100',
  //                                         variant : 'standard'
  //                                     },
  //                                     value_store : ["name"],
  //                                     eval_value : '',
  //                                     value : field.name,
  //                                     error : field.error,
  //                                     async_values : false,
  //                                     api_config : {},
  //                                     values : this.state.wv_fields,
  //                                     render_condition : '',
  //                                     mandatory : true
  //                                 }}
  //                                 handleChange = {(state_key, value, id) => this.handleConfigFieldChange(state_key, value, index, ops_name)}
  //                             />
  //                         </div>
  //                         <div style ={{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
  //                             <div style = {{width : '50%', padding : '5px'}}>
  //                                 <FDropDown
  //                                     key = {ops_name + index + 'role' + field.role}
  //                                     instance = {{
  //                                         label : 'Field Role',
  //                                         helper_text : field.error === true ? field.error_message : 'Choose the Field Role',
  //                                         props : {
  //                                             width : '50',
  //                                             variant : 'standard'
  //                                         },
  //                                         value_store : ["role"],
  //                                         eval_value : '',
  //                                         value : field.role,
  //                                         error : field.error,
  //                                         async_values : false,
  //                                         api_config : {},
  //                                         values : this.state.field_roles,
  //                                         render_condition : '',
  //                                         mandatory : true,
  //                                     }}
  //                                     handleChange = {(state_key, value) => this.handleConfigFieldChange(state_key, value, index, ops_name)}
  //                                 />
  //                             </div>
  //                             <div style = {{width : '50%', padding : '5px', paddingTop : '14px'}}>
  //                                 {ops_name !== 'TopicModel' ? this.renderSlider(ops_fields, index, ops_name) : null}
  //                             </div>
  //                         </div>
  //                     </Paper>
  //                 </Grid>
  //             </Zoom>
  //         )
  //     })

  //     return fields
  // }

  // renderSlider = (ops_fields, index, ops_name) => {
  //     let field = ops_fields[index]

  //     let value

  //     this.state.configs.map(config => {
  //         if (config.operation === ops_name) {
  //             value = config.fields[index].weight
  //         }
  //     })
  //     if (field.role === 'Predictor') {
  //         return (
  //             <Fragment>
  //                 <Typography>
  //                     Weight: {value < 0 ? null : value}
  //                 </Typography>
  //                 <Slider
  //                     value = {value}
  //                     onChange = {(event, value) => this.handleWeightConfigFieldChange('weight', value, index, ops_name)}
  //                     // marks = {[{value: 0, label: '0.00'}, {value: 1, label : '1.00'}]}
  //                     min = {0}
  //                     max = {1}
  //                     step = {0.01}
  //                     valueLabelDisplay = 'auto'
  //                     disabled = {this.state.submitted_ops.includes(ops_name) ? true : false}
  //                 />
  //             </Fragment>
  //         )
  //     }
  // }

  // renderOpsTab = (config) => {
  //     return (
  //         <Typography align = 'center'>To Be Developed</Typography>
  //     )
  // }

  handleTabChange = (event, value) => {
    this.setState({
      ...this.state,
      tabValue: value,
      insetTabValue: 0,
    });
  };

  // handleInsetTabChange = (event, value) => {
  //     this.setState({
  //         ...this.state,
  //         insetTabValue : value
  //     })
  // }

  // renderResetConfirmation = () => {
  //     return (
  //         <ThemeProvider theme = {blue_theme}>
  //             <Dialog
  //                 open={this.state.reset_dialog}
  //             >
  //                 <DialogTitle id="alert-dialog-title">Reset Field Configuration ?</DialogTitle>
  //                 <DialogContent>
  //                     <DialogContentText id="alert-dialog-description">
  //                         All fields added to the field configuration will be deleted. This action cannot be undone. Do you like to reset?
  //                     </DialogContentText>
  //                 </DialogContent>
  //                 <DialogActions>
  //                     <Button color="secondary" onClick = {() => this.resetConfig(this.state.cur_ops_name)}>
  //                         Reset
  //                     </Button>
  //                     <Button color="primary" autoFocus onClick = {() => this.setState({...this.state, reset_dialog : false})}>
  //                         Cancel
  //                     </Button>
  //                 </DialogActions>
  //             </Dialog>
  //         </ThemeProvider>
  //     )
  // }

  // renderSubmitConfirmation = () => {

  // }

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Paper
          elevation={4}
          square
          style={{
            width: "100%",
            height: this.props.maxHeight,
            overflow: "hidden",
          }}
        >
          {this.state.loading ? (
            <ThemeProvider theme={blue_theme}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </ThemeProvider>
          ) : (
            <>
              <div ref={this.tabPanel}>
                <Paper elevation={1} square style={{ marginBottom: "2px" }}>
                  <ThemeProvider theme={blue_theme}>
                    <Tabs
                      value={this.state.tabValue}
                      onChange={this.handleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      centered
                    >
                      {this.renderTabs()}
                    </Tabs>
                  </ThemeProvider>
                </Paper>
              </div>
              {this.renderTabPanels(this.state.tabValue)}
            </>
          )}
        </Paper>
      </Fragment>
    );
  }
}

export default withStyles(styles)(ConfigureOps);
